import { Vraag } from '../claims/vraag';

export class CurrentvraagEventargs {
    constructor(
        public currentVraag: Vraag,
        public vragenReeks: Vraag[]
    ) {
    }
}
